import { reactive } from 'vue';

const globalNavState = reactive({
    mobileNavShow: false
})

export function useNavTools() {

    const mobileNavShow = computed(() => globalNavState.mobileNavShow);
    const toggleMobileNav = () => globalNavState.mobileNavShow = !globalNavState.mobileNavShow;
    const hideMobileNav = () => globalNavState.mobileNavShow = false;

    return {
        mobileNavShow,
        toggleMobileNav,
        hideMobileNav,
    }
}